import React, { useState } from "react";
import AddNote from "../AddNote/AddNote";
import { Notes } from "../../../../assets/js/image";
import { changeDateAndAddTime } from "../../../VendorOnboarding/Views/VendorProfile/helpers";
import { httpPostCreateOrUpdateNote } from "../../../../service/httpClient";

const NoteRenderer = ({ value, data }) => {
  const [showNoteInputModal, setShowNoteInputModal] = useState(false);
  const _vendorId = value;
  const _vendorName = data.vendorCorpName;
  const _vendorDuns = data.duns;

  const addNoteHandler = (_notes) => {
    let notes = { ..._notes };
    notes.createdDate = changeDateAndAddTime(
      new Date(_notes.createdDate)
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "-")
    );
    httpPostCreateOrUpdateNote(notes).then((response) => {
      clearModalVisibilityArea();
    });
  };

  const clearModalVisibilityArea = () => {
    setShowNoteInputModal(false);
  };

  return (
    <div>
      <Notes
        style="width: 20px;"
        id="notes"
        onClick={() => setShowNoteInputModal(true)}
      />
      {showNoteInputModal && (
        <AddNote
          addNote={addNoteHandler}
          vendorName={_vendorName}
          vendorId={_vendorId}
          vendorDuns={_vendorDuns}
          showTriggerButton={false}
          shouldModalVisible={showNoteInputModal}
          shouldModalVisibleHandler={clearModalVisibilityArea}
        />
      )}
    </div>
  );
};

export default NoteRenderer;
